import { Alert } from 'antd';
import React from 'react'
import RichTextViewer from '../../helpers/components/rich_text_viewer';
import { useSelector } from 'react-redux';

const TopBanner = ({ height, bannerQuill, type = 'info', }) => {
    return (
        <>
            <Alert
            type={type}
            style={{ borderRadius : 0, maxHeight: height, }}
            message={(
                <>
                    <RichTextViewer
                    value={bannerQuill}
                    className='ticket-label ticket-title h1 banner-quill'
                    style={{ fontSize:12, color:'var(--secondary-text-color)', whiteSpace : 'wrap', margin : 0, }}
                    />
                </>
            )}
            />
        </>
    )
}

export default TopBanner;